import React from "react";

import {
  Container,
  Heading,
  SubHeading,
  InfoContainer,
  Text,
} from "./styles/privacyPolicy";

export default function PrivacyPolicy({ children, ...restProps }) {
  return <Container {...restProps}>{children}</Container>;
}

PrivacyPolicy.InfoContainer = function PrivacyPolicyInfoContainer({
  children,
  ...restProps
}) {
  return <InfoContainer {...restProps}>{children}</InfoContainer>;
};

PrivacyPolicy.Heading = function PrivacyPolicyHeading({
  children,
  ...restProps
}) {
  return <Heading {...restProps}>{children}</Heading>;
};

PrivacyPolicy.SubHeading = function PrivacyPolicySubHeaing({
  children,
  ...restProps
}) {
  return <SubHeading {...restProps}>{children}</SubHeading>;
};

PrivacyPolicy.Text = function PrivacyPolicyText({ children, ...restProps }) {
  return <Text {...restProps}>{children}</Text>;
};
